<!-- Form -->
@if (headerForm) {
  <medsurf-design-form-control-form
    [formGroup]="headerForm"
    (onSubmit)="onSubmit()">
    <!-- Header -->
    <medsurf-design-form-control-input-text [formField]="false"
      [inputClass]="FlatModels.TextDesignModels.TextDesignClass.SLIDE_CAPTION"
      [control]="headerForm.controls.header"
      [placeholder]="'global.caption'"
    (valueChange)="onSubmit()"></medsurf-design-form-control-input-text>
  </medsurf-design-form-control-form>
}
